import companyApi from "@/api/company-api";
import * as formulajs from "@formulajs/formulajs";
import { parse, visit } from "excel-formula-parser";
import * as tokens from 'excel-formula-tokenizer';

export default {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    data() {
        return {
            formulas: [
                {name: "IF", value: "IF"},
                {name: "ABS", value: "ABS"},
                {name: "SUM", value: "SUM"},
                {name: "SUMIF", value: "SUMIF"},
                {name: "COUNTIF", value: "COUNTIF"},
                {name: "MIN", value: "MIN"},
                {name: "MAX", value: "MAX"},
                {name: "AVERAGE", value: "AVERAGE"},
                {name: "ROUND", value: "ROUND"},
            ],
            formulaIf: {condition: null as any, statementTrue: null as any, statementFalse: null as any},
            formulaAbs: {values: [] as any[]},
            formulaSum: {values: [] as any[]},
            formulaSumIf: {range: [] as any, condition: null as any, sumRange: [] as any},
            formulaCountIf: {range: null as any, condition: null as any},
            formulaAverage: {values: [] as any[]},
            formulaRound: {number: null as any, numOfDecimal: 0},
            formulaMin: {values: [] as any[]},
            formulaMax: {values: [] as any[]},
        };
    },
    computed: {
        //
    },
    methods: {
        parseToken(formula: any, rowIndex: any, columnIndex: any) {
            try {
                return tokens.tokenize(formula) as any;
            }
            
            catch (err) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.$toast.add({severity: "error", summary: "Invalid syntax", detail: this.getLetterByCurrentStep(String.fromCharCode(65), columnIndex) + (rowIndex + 1) + ' : ' + formula});
                return null;
            }
        },
        parseFormulas(formula: any, companyReportSheets: any, sheetIndex: any, rowIndex: any, columnIndex: any) {
            try {
                return parse(formula) as any;
            }
            
            catch (err) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.$toast.add({severity: "error", summary: "Invalid syntax in " + companyReportSheets[sheetIndex].sheet_code + ' - ' + companyReportSheets[sheetIndex].sheet_name, detail: (String.fromCharCode(64 + (columnIndex + 1)) + (rowIndex + 1)) + ' : ' + formula});
                companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].invalid = true;
                return null;
            }
        },
        getLetter(value: any) {
            if (value.match(/[A-Za-z]+/) != null) {
                return (value.match(/[A-Za-z]+/))[0];
            }
            return null;
        },
        getNumber(value: any) {
            if (value.match(/\d+/) != null) {
                return Number(value.match(/\d+/));
            }
            return null;
        },
        getLetterNumber(value: any) {
            if (value.match(/[A-Za-z]+/) != null) {
                return (value.match(/[A-Za-z]+/))[0] + Number(value.match(/\d+/));
            }
            return null;
        },
        getRowIndex(value: any) {
            return (Number(value.match(/\d+/)) - 1);
        },
        getColumnIndex(value: any) {
			const chars = value.match(/[A-Za-z]+/)[0];
			let colIndex = 0;
            for (let i = 0; i < chars.length; i++) {
                const charValue = chars.charCodeAt(i) - 64;
                colIndex = colIndex * 26 + charValue;
            }
            return colIndex - 1;
        },
        getHeader(rowIndex: any, columnIndex: any) {
            return this.getHeaderLetter(columnIndex) + (rowIndex + 1);
        },
        getHeaderLetter(columnIndex: any) {
            // return (String.fromCharCode(64 + (columnIndex + 1)));
            return this.getLetterByCurrentStep(String.fromCharCode(64 + 1), columnIndex);
        },
        getChildHeader(value: any) {
            return value.match(/^(-?)([a-zA-Z0-9_!]+)/)[2];
        },
        setIfValues(content: any) {
            if (content != null && content.template != null) {
                let header = null as any;
                const rowLength = content.template.length;
                for (let r = 0; r < rowLength; r++) {
                    const columnLength = content.template[r].columns.length;
                    for (let c = 0; c < columnLength; c++) {
                        if (content.template[r].columns[c] != null) {
                            content.template[r].columns[c].actualValue = null;
                            if (content.template[r].columns[c].component != null && content.template[r].columns[c].component == 'FORMULA') {
                                if (content.template[r].columns[c].value != null && content.template[r].columns[c].value.toUpperCase().startsWith('=IF')) {
                                    header = this.getHeader(r, c);
                                    
                                    content.template[r].columns[c].actualValue = this.getFormulaValue(parse(content.template[r].columns[c].value.substring(1)), header, null, [{template: content.template}], 0);
                                }
                            }
                            
                            if (content.template[r].columns[c].actualValue == null) {
                                delete content.template[r].columns[c].actualValue;
                            }
                        }
                    }
                }
                header = null;
            }
        },
        getFormulaChilds(parserFunction: any) {
            //console.log(parserFunction);
            let childs = [] as any[];
            
            try {
                if (parserFunction != null) {
                    if (parserFunction.type == 'function') {
                        parserFunction.arguments.forEach((argument: any) => {
                            if (argument.type != 'text') {
                                this.getFormulaChildsByArgument(argument, childs);
                            }
                        });
                    }
                    
                    else if (parserFunction.type == 'binary-expression') {
                        this.getFormulaChildsByArgument(parserFunction, childs);
                    }
                    
                    else if (parserFunction.type == 'cell') {
                        this.getFormulaChildsByArgument(parserFunction, childs);
                    }
                    
                    else if (parserFunction.type == 'unary-expression') {
                        this.getFormulaChildsByArgument(parserFunction.operand, childs);
                    }
                }
                return childs;
            }
            
            finally {
                childs = null as any;
            }
        },
        getFormulaChildsByArgument(argument: any, childs: any) {
            //console.log(argument);
            if (argument.type == 'cell-range') {
                if (this.getLetterNumber(argument.left.key) != null && this.getLetterNumber(argument.right.key) != null) {
                    let n = '';
                    if (argument.left.key.includes('!')) {
                        n = argument.left.key.split('!')[0] + '!';
                        argument.left.key = argument.left.key.split('!')[1];
                    }
                    
                    const columnStart = this.getColumnIndex(argument.left.key);
                    const columnEnd = this.getColumnIndex(argument.right.key);
                    const rowStart = this.getRowIndex(argument.left.key);
                    const rowEnd = this.getRowIndex(argument.right.key);
                    
                    if (this.getLetter(argument.left.key) == this.getLetter(argument.right.key)) {
                        for (let r = rowStart; r <= rowEnd; r++) {
                            childs.push(n + this.getHeader(r, columnStart));
                        }
                    }
                    
                    else if (rowStart == rowEnd) {
                        for (let c = columnStart; c <= columnEnd; c++) {
                            childs.push(n + this.getHeader(rowStart, c));
                        }
                    }
                    
                    else {
                        for (let c = columnStart; c <= columnEnd; c++) {
                            for (let r = rowStart; r <= rowEnd; r++) {
                                childs.push(n + this.getHeader(r, c));
                            }
                        }
                    }
                    n = null as any;
                }
                
                else {
                    if (this.getLetterNumber(argument.left.key) != null) {
                        childs.push(this.getLetterNumber(argument.left.key));
                    }
                    
                    if (this.getLetterNumber(argument.right.key) != null) {
                        childs.push(this.getLetterNumber(argument.right.key));
                    }
                }
            }
            
            else if (argument.type == 'binary-expression') {
                if (argument.left.operand != null) {
                    if (argument.left.operand.operand != null) {
                        this.getFormulaChildsByArgument(argument.left.operand.operand, childs);
                    }
                    
                    else {
                        this.getFormulaChildsByArgument(argument.left.operand, childs);
                    }
                    this.getFormulaChildsByArgument(argument.right, childs);
                }
                
                else {
                    if (argument.left.type == 'function') {
                        argument.left.arguments.forEach((argument: any) => {
                            if (argument.type != 'text') {
                                this.getFormulaChildsByArgument(argument, childs);
                            }
                        });
                    }
                    
                    else {
                        this.getFormulaChildsByArgument(argument.left, childs);
                    }
                    if (argument.right.operand != null) {
                        if (argument.right.operand.operand != null) {
                            this.getFormulaChildsByArgument(argument.right.operand.operand, childs);
                        }
                        
                        else {
                            this.getFormulaChildsByArgument(argument.right.operand, childs);
                        }
                        this.getFormulaChildsByArgument(argument.left, childs);
                    }
                    
                    else {
                        if (argument.right.type == 'function') {
                            argument.right.arguments.forEach((argument: any) => {
                                if (argument.type != 'text') {
                                    this.getFormulaChildsByArgument(argument, childs);
                                }
                            });
                        }
                        
                        else {
                            this.getFormulaChildsByArgument(argument.right, childs);
                        }
                    }
                }
            }
            
            else if (argument.type == 'function') {
                argument.arguments.forEach((argument: any) => {
                    if (argument.type != 'text') {
                        this.getFormulaChildsByArgument(argument, childs);
                    }
                });
            }
            
            else if (argument.type == 'cell' || argument.type == 'unary-expression') {
                if (argument.operand != null) {
                    if (argument.operand.operand != null) {
                        this.getFormulaChildsByArgument(argument.operand.operand, childs);
                    }
                }
                
                else {
                    childs.push(argument.key);
                }
            }
        },
        isInvalidValue(value: any) {
            if (value != undefined && value != null && value == '#VALUE!') {
                return true;
            }
            return false;
        },
        hasInvalidValue(values: any) {
            if (values != undefined && values != null && values.length > 0) {
                for (let i = 0; i < values.length; i++) {
                    if (Array.isArray(values[i])) {
                        const hasInvalidValue = this.hasInvalidValue(values[i]);
                        if (hasInvalidValue) {
                            return true;
                        }
                    }
                    
                    else {
                        if (values[i] == '#VALUE!') {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        getNonZeroNumbers(values: any) {
            // Recursively flatten the (possibly nested) value list and keep only real,
            // non-zero numbers. Zero values (blank/absent cells are collected as 0) are dropped
            // so AVERAGE only sums and counts cells that actually carry a value.
            // Numeric strings (e.g. "4.85") are coerced; "zero" is decided on the project's
            // 6-decimal standard so tiny floating-point residuals that display as 0 are
            // treated as 0 instead of inflating the count.
            const result = [] as number[];
            const flatten = (value: any) => {
                if (Array.isArray(value)) {
                    for (let i = 0; i < value.length; i++) {
                        flatten(value[i]);
                    }
                }

                else if (value != null && value !== '' && !isNaN(value)) {
                    const rounded = Number(Number(value).toFixed(6));
                    if (rounded !== 0) {
                        result.push(rounded);
                    }
                }
            };
            flatten(values);
            return result;
        },
        isCwkMode() {
            // Resolve whether the current calculation is running in CWK mode. The interactive sheet
            // dialog exposes the mode via the `type` prop, while the batch calculation entry point
            // (setValues, used by the CWK detail/configuration pages) records it in `calculationType`.
            // When neither is set (e.g. template editor) we treat it as non-CWK.
            return (this as any).type === 'cwk' || (this as any).calculationType === 'cwk';
        },
        isNumericHeaderCell(cell: any) {
            // HEADER cells keep their content in `value` (like LABEL/LONGLABEL), not `actualValue`.
            // In the CWK foreign template the exchange rate lives in a HEADER row, and the foreign->local
            // translation formula =ROUND(amount * rate, 0) references that HEADER cell. Because every cell
            // reference below reads `actualValue` for anything other than LABEL/LONGLABEL, the rate resolved
            // to 0 and the web-recomputed translated figure collapsed to 0 - while the backend
            // (FormulaManager.calculate_round_formula, which reads HEADER/LABEL/LONGLABEL from `value`)
            // stayed correct, so the Excel export was right and the web "Sheet mode" was wrong.
            // Read numeric HEADER cells from `value` to match the backend. This also applies to RPK
            // (e.g. the "sensi" sheet where H4 is a HEADER "1%" referenced by =ROUND(H4*G12,0)):
            // without this, a positive HEADER reference resolved to actualValue (null -> 0) and the
            // formula collapsed to 0, while the negative reference (=ROUND(-H4*G6,0)) worked because
            // that code path reads HEADER from `value` directly. Restricted to numeric values, so text
            // headers (currency codes, IDs) keep falling back to actualValue and are never injected
            // into arithmetic.
            if (cell == null || cell.component != 'HEADER' || cell.value == null) {
                return false;
            }
            const raw = cell.value.toString().replace('%', '').trim();
            return raw != '' && !isNaN(Number(raw));
        },
        getFormulaValue(parserFunction: any, header: any, newValue: any, companyReportSheets: any, sheetIndex: any) {
            //console.log(parserFunction);
            let values = [] as any[];
            let paramValues = [] as any[];
            
            try {
                if (parserFunction.type == 'function') {
                    parserFunction.arguments.forEach((argument: any) => {
                        if (argument == undefined || argument == null) {
                            values.push(0);
                        }
                        
                        else {
                            if (argument.type != null && argument.type != 'text') {
                                this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, values);
                            }
                            
                            else {
                                values.push(argument.value);
                            }
                        }
                        
                        paramValues.push(values);
                        values = [] as any[];
                    });
                }
                
                else if (parserFunction.type == 'binary-expression') {
                    let value = null as any;
                    
                    try {
                        value = this.getFormulaValueByArgument(parserFunction, header, newValue, companyReportSheets, sheetIndex, values);
                        paramValues.push(value);
                    }
                    
                    finally {
                        value = null;
                    }
                }
                
                else if (parserFunction.type == 'cell' || parserFunction.type == 'unary-expression') {
                    this.getFormulaValueByArgument(parserFunction, header, newValue, companyReportSheets, sheetIndex, values);
                    paramValues = values;
                    values = [] as any[];
                }
                
                else if (parserFunction.type == 'number') {
                    paramValues.push(parserFunction.value);
                }
                
                else if (parserFunction.type == 'text') {
                    paramValues.push(parserFunction.value);
                }
                
                //console.log(paramValues);
                if (parserFunction.name != null) {
                    if (parserFunction.name != null && parserFunction.name == 'SUM') {
                        //console.log(formulajs.SUM(paramValues));
                        return (this.hasInvalidValue(paramValues) ? '#VALUE!' : formulajs.SUM(paramValues));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'IF') {
                        //console.log(formulajs.IF(paramValues[0][0], paramValues[1][0], paramValues[2][0]));
                        return (this.isInvalidValue(paramValues[0][0]) ? '#VALUE!' : formulajs.IF(paramValues[0][0], paramValues[1][0], paramValues[2][0]));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'SUMIF') {
                        //console.log(formulajs.SUMIF(paramValues[0], paramValues[1], paramValues[2]));
                        return (this.isInvalidValue(paramValues[0]) ? '#VALUE!' : formulajs.SUMIF(paramValues[0], paramValues[1], paramValues[2]));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'COUNTIF') {
                        //console.log(formulajs.COUNTIF(paramValues[0], paramValues[1]));
                        return (this.isInvalidValue(paramValues[0]) ? '#VALUE!' : formulajs.COUNTIF(paramValues[0], paramValues[1]));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'ABS') {
                        //console.log(formulajs.ABS(paramValues[0]));
                        return (this.isInvalidValue(paramValues[0]) ? '#VALUE!' : formulajs.ABS(paramValues[0]));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'MAX') {
                        //console.log(formulajs.MAX(paramValues));
                        // MAX always treats 0 as a valid value (blank/absent cells are collected as 0).
                        return (this.hasInvalidValue(paramValues) ? '#VALUE!' : formulajs.MAX(paramValues));
                    }

                    else if (parserFunction.name != null && parserFunction.name == 'MIN') {
                        //console.log(formulajs.MIN(paramValues));
                        if (this.hasInvalidValue(paramValues)) { return '#VALUE!'; }
                        // In CWK mode, MIN ignores 0 values (blank/absent cells are collected as 0) just like
                        // AVERAGE, so the minimum is taken only over cells that carry a non-zero value. In RPK
                        // mode the original behaviour is kept where 0 is a valid candidate for the minimum.
                        if (this.isCwkMode()) {
                            const nums = this.getNonZeroNumbers(paramValues);
                            return (nums.length == 0 ? 0 : formulajs.MIN(nums));
                        }
                        return formulajs.MIN(paramValues);
                    }

                    else if (parserFunction.name != null && parserFunction.name == 'AVERAGE') {
                        //console.log(formulajs.AVERAGE(paramValues));
                        if (this.hasInvalidValue(paramValues)) { return '#VALUE!'; }
                        // AVERAGE ignores both blank cells and 0 values, so the average is only over cells that carry a non-zero value.
                        const nums = this.getNonZeroNumbers(paramValues);
                        return (nums.length == 0 ? 0 : formulajs.AVERAGE(nums));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'ROUND') {
                        //console.log(formulajs.ROUND(paramValues[0], paramValues[1]));
                        return (this.isInvalidValue(paramValues[0]) ? '#VALUE!' : formulajs.ROUND(paramValues[0], paramValues[1]));
                    }
                    
                    else if (parserFunction.name != null && parserFunction.name == 'TEXT') {
                        //console.log(formulajs.TEXT(paramValues[0], paramValues[1].toString()));
                        return (this.isInvalidValue(paramValues[0]) ? '#VALUE!' : formulajs.TEXT(paramValues[0], paramValues[1].toString()));
                    }
                }
                return (this.isInvalidValue(paramValues[0]) ? '#VALUE!' : paramValues[0]);
            }
            
            finally {
                values = null as any;
                paramValues = null as any;
            }
        },
        getFormulaValueByArgument(argument: any, header: any, newValue :any, companyReportSheets: any, sheetIndex: any, values: any) {
			if (argument.type == 'cell-range') {
				if (this.getLetterNumber(argument.left.key) != null && this.getLetterNumber(argument.right.key) != null) {
					if (argument.left.key.includes('!')) {
						argument.left.key = argument.left.key.split('!')[1];
					}
					
					const columnStart = this.getColumnIndex(argument.left.key);
					const columnEnd = this.getColumnIndex(argument.right.key);
					const rowStart = this.getRowIndex(argument.left.key);
					const rowEnd = this.getRowIndex(argument.right.key);
					
					if (this.getLetter(argument.left.key) == this.getLetter(argument.right.key)) {
						for (let r = rowStart; r <= rowEnd; r++) {
							if (header == (this.getHeader(r, columnStart))) {
								values.push(newValue);
							}
																
							else {
								if (companyReportSheets[sheetIndex].template[r] != null && companyReportSheets[sheetIndex].template[r].columns[columnStart] != null && companyReportSheets[sheetIndex].template[r].columns[columnStart].component != null) {
									values.push((companyReportSheets[sheetIndex].template[r] == null || companyReportSheets[sheetIndex].template[r].columns[columnStart] == null || companyReportSheets[sheetIndex].template[r].columns[columnStart].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[r].columns[columnStart].actualValue));
								}
							}
						}
					}
														
					else if (rowStart == rowEnd) {
						for (let c = columnStart; c <= columnEnd; c++) {
							if (header == this.getHeader(rowStart, c)) {
								values.push(newValue);
							}
							
							else {
								if (companyReportSheets[sheetIndex].template[rowStart] != null && companyReportSheets[sheetIndex].template[rowStart].columns[c] != null && companyReportSheets[sheetIndex].template[rowStart].columns[c].component != null) {
									values.push((companyReportSheets[sheetIndex].template[rowStart] == null || companyReportSheets[sheetIndex].template[rowStart].columns[c] == null || companyReportSheets[sheetIndex].template[rowStart].columns[c].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowStart].columns[c].actualValue));
								}
							}
						}
					}
	
					else {
						for (let c = columnStart; c <= columnEnd; c++) {
							for (let r = rowStart; r <= rowEnd; r++) {
								if (header == this.getHeader(r, c)) {
									values.push(newValue);
								}
																	
								else {
									if (companyReportSheets[sheetIndex].template[r] != null && companyReportSheets[sheetIndex].template[r].columns[c] != null && companyReportSheets[sheetIndex].template[r].columns[c].component != null) {
										values.push((companyReportSheets[sheetIndex].template[r] == null || companyReportSheets[sheetIndex].template[r].columns[c] == null || companyReportSheets[sheetIndex].template[r].columns[c].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[r].columns[c].actualValue));
									}
								}
							}
						}
					}
				}
				
				else {
					if (this.getLetterNumber(argument.left.key) != null) {
						const rowIndex = this.getRowIndex(argument.left.key);
						const columnIndex = this.getColumnIndex(argument.left.key);
						
						if (header == this.getLetterNumber(argument.left.key)) {
							values.push(newValue);
						}
						
						else {
							if (companyReportSheets[sheetIndex].template[rowIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component != null) {
								values.push((companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue));
							}
						}
					}
					
					else {
						values.push(argument.right.key);
					}
					
					if (this.getLetterNumber(argument.right.key) != null) {
						const rowIndex = this.getRowIndex(argument.right.key);
						const columnIndex = this.getColumnIndex(argument.right.key);

						if (header == this.getLetterNumber(argument.right.key)) {
							values.push(newValue);
						}
						
						else {
							if (companyReportSheets[sheetIndex].template[rowIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component != null) {
								values.push((companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue));
							}
						}
					}
					
					else {
						values.push(argument.left.key);
					}
				}
			}
			
			else if (argument.type == 'binary-expression') {
				let leftValue = null as any;
				let rightValue = null as any;

				try {
					if (argument.left.operand != null) {
						if (argument.left.operand.operand != null) {
							let v = [] as any[];
							this.getFormulaValueByArgument(argument.left.operand.operand, header, newValue, companyReportSheets, sheetIndex, v);
							if (argument.left.operand.operator != null) {
								leftValue = (v[0] == 0 ? v[0] : v[0] * -1 * -1);
							}

							else {
								leftValue = (v[0] == 0 ? v[0] : v[0] * -1);
							}
							values.length = 0;
							v = null as any;
						}

						else if (argument.left.operand.type == 'number') {
							leftValue = (argument.left.operand.value == 0 ? argument.left.operand.value : argument.left.operand.value * -1);
						}

						else if (argument.left.operand.type == 'binary-expression') {
							leftValue = this.getFormulaValueByArgument(argument.left.operand, header, newValue, companyReportSheets, sheetIndex, values);
							leftValue = (leftValue == 0 ? leftValue : leftValue * -1);
							values.length = 0;
						}
						
						else if (argument.left.operand.type == 'function') {
							let v = [] as any[];
							let t = null as any;

							argument.left.operand.arguments.forEach((argument: any) => {
								if (argument.type != 'text') {
									this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, v);
								}
							});
							t = this.evaluateFunction(argument.left.operand.name, v);
							leftValue = (t == 0 ? t : t * -1);

							t = null;
							v = null as any;
						}

						else {
							const rowIndex = this.getRowIndex(argument.left.operand.key);
							const columnIndex = this.getColumnIndex(argument.left.operand.key);
							
							if (header == (this.getLetterNumber(argument.left.operand.key))) {
								leftValue = (newValue == 0 ? newValue : newValue * -1);
							}
							
							else {
								if (companyReportSheets[sheetIndex].template[rowIndex] != null &&  companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value != null && (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LONGLABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'HEADER')) {
									if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.toString().indexOf('%') != -1) {
										leftValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') == undefined || null ? 0 : (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') / 100) * -1);
									}
	
									else{
										leftValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value * -1);
									}
								} 
	
								else {
									if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.toString().indexOf('%') != -1) {
										leftValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') == undefined || null ? 0 : (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') / 100) * -1);	
									}
									
									else {
										leftValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue * -1);	
									}
								}
							}
						}
					}

					else {
						if (argument.left.type == 'number') {
							leftValue = argument.left.value;
						}

						else if (argument.left.type == 'cell') {
							const rowIndex = this.getRowIndex(argument.left.key);
							const columnIndex = this.getColumnIndex(argument.left.key);
							
							if (this.getNumber(argument.left.key) == null) {
								leftValue = argument.left.key;
							}
							
							else {
								if (header == this.getLetterNumber(argument.left.key)) {
									if (newValue != null && newValue.toString().indexOf('%') != -1) {
										leftValue = newValue.toString().indexOf('%') != -1 ? newValue.toString().replace('%', '') / 100 : newValue;
									}
									
									else {
										leftValue = newValue == undefined || null ? 0 : newValue;
									}
								}
																
								else {
									if (companyReportSheets[sheetIndex].template[rowIndex] != null &&  companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value != null && (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LONGLABEL' || this.isNumericHeaderCell(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex]))) {
										if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.toString().indexOf('%') != -1) {
											leftValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') / 100);
										}
		
										else{
											leftValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value);
										}
									} 
		
									else {
										if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.toString().indexOf('%') != -1) {
											leftValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') / 100);	
										}
										
										else {
											leftValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue);	
										}
									}
								}
							}
						}

						else if (argument.left.type == 'function') {
							let v = [] as any[];
							argument.left.arguments.forEach((argument: any) => {
								if (argument.type != 'text') {
									this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, v);
								}
								
								else {
									v.push(argument.value);
								}
							});
							leftValue = this.evaluateFunction(argument.left.name, v);
							v = null as any;
						}

						else if (argument.left.type == 'text') {
							leftValue = argument.left.value;
						}
		
						else {
							leftValue = this.getFormulaValueByArgument(argument.left, header, newValue, companyReportSheets, sheetIndex, values);
							values.length = 0;
						}
					}

					if (argument.right.operand != null) {
						if (argument.right.operand.operand != null) {
							let v = [] as any[];
							this.getFormulaValueByArgument(argument.right.operand.operand, header, newValue, companyReportSheets, sheetIndex, v);
							if (argument.right.operand.operator != null) {
								rightValue = (v[0] == 0 ? v[0] : v[0] * -1 * -1);
							}

							else {
								rightValue = (v[0] == 0 ? v[0] : v[0] * -1);
							}
							values.length = 0;
							v = null as any;
						}

						else if (argument.right.operand.type == 'number') {
							rightValue = (argument.right.operand.value == 0 ? argument.right.operand.value : argument.right.operand.value * -1)
						}

						else if (argument.right.operand.type == 'binary-expression') {
							rightValue = this.getFormulaValueByArgument(argument.right.operand, header, newValue, companyReportSheets, sheetIndex, values);
							rightValue = (rightValue == 0 ? rightValue : rightValue * -1);
							values.length = 0;
						}
											
						else if (argument.right.operand.type == 'function') {
							let v = [] as any[];
							let t = null as any;

							argument.right.operand.arguments.forEach((argument: any) => {
								if (argument.type != 'text') {
									this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, v);
								}
							});
							t = this.evaluateFunction(argument.right.operand.name, v);
							rightValue = (t == 0 ? t : t * -1);
								
							t = null;
							v = null as any;
						}

						else {
							const rowIndex = this.getRowIndex(argument.right.operand.key);
							const columnIndex = this.getColumnIndex(argument.right.operand.key);

							if (header ==  this.getLetterNumber(argument.right.operand.key)) {
								rightValue = (newValue == 0 ? newValue : newValue * -1);
							}
							
							else {
								if (companyReportSheets[sheetIndex].template[rowIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value != null && (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LONGLABEL' || this.isNumericHeaderCell(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex]))) {
									if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.toString().indexOf('%') != -1) {
										rightValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') == undefined || null ? 0 : (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') / 100) * -1);
									}
	
									else{
										rightValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value * -1);
									}
								} 
	
								else {
									if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.toString().indexOf('%') != -1) {
										rightValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') == undefined || null ? 0 : (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') / 100) * -1);	
									}
	
									else {
										rightValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue * -1);
									}
								}
							}
						}
					} 

					else {
						if (argument.right.type == 'number') {
							rightValue = argument.right.value;
						}

						else if (argument.right.type == 'cell') {
							const rowIndex = this.getRowIndex(argument.right.key);
							const columnIndex = this.getColumnIndex(argument.right.key);
							
							if (this.getNumber(argument.right.key) == null) {
								rightValue = argument.right.key;
							}
							
							else {
								if (header == this.getLetterNumber(argument.right.key)) {
									if (newValue != null && newValue.toString().indexOf('%') != -1) {
										rightValue = newValue.toString().indexOf('%') != -1 ? newValue.toString().replace('%', '') / 100 : newValue;
									}
									
									else {
										rightValue = newValue == undefined || null ? 0 : newValue;
									}
								}
																
								else {
									if (companyReportSheets[sheetIndex].template[rowIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value != null && (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LONGLABEL' || this.isNumericHeaderCell(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex]))) {
										if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.toString().indexOf('%') != -1) {
											rightValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') / 100);
										}
		
										else{
											rightValue = (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value);
										}
									} 
		
									else {
										if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.toString().indexOf('%') != -1) {
											rightValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') / 100);	
										}
		
										else {
											rightValue = (companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue);
										}
									}
								}
							}
						}

						else if (argument.right.type == 'function') {
							let v = [] as any[];
							argument.right.arguments.forEach((argument: any) => {
								if (argument.type != 'text') {
									this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, v);
								}

								else {
									v.push(argument.value);
								}
							});
							rightValue = this.evaluateFunction(argument.right.name, v);
							v = null as any;
						}

						else if (argument.right.type == 'text') {
							rightValue = argument.right.value;
						}

						else {
							rightValue = this.getFormulaValueByArgument(argument.right, header, newValue, companyReportSheets, sheetIndex, values);
							values.length = 0;
						}
					}		

					if (argument.operator != null) {
						let value = null as any;
						
						try {
							value = this.evaluateExpression(argument.operator, leftValue, rightValue);
							values.push(value);
							return value;
						}

						finally {
							value = null;
						}
					}
				}

				finally {
					leftValue = null;
					rightValue = null;
				}
			}

			else if (argument.type == 'function') {
				let v = [] as any[];
				argument.arguments.forEach((argument: any) => {
					if (argument.type != 'text') {
						this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, v);
					}
				});

				if (argument.name == 'ROW') {
					values.push(this.evaluateFunction(argument.name, argument.arguments[0].key));
				}

				else{
					values.push(this.evaluateFunction(argument.name, v));
				}
				v = null as any;
			}

			else if (argument.type == 'cell' || argument.type == 'unary-expression' ) {
				if (argument.refType == null && argument.key != null) {
					values.push(argument.key);
				}

				else {
					if (argument.operand != null) {
						if (argument.operand.operand != null) {
							let v = [] as any[];
							this.getFormulaValueByArgument(argument.operand.operand, header, newValue, companyReportSheets, sheetIndex, v);
							if (argument.operand.operator != null) {
								values.push((v[0] == 0 ? v[0] : v[0] * -1 * -1));
							}

							else {
								values.push((v[0] == 0 ? v[0] : v[0] * -1));
							}
							v = null as any;
						}
	
						else if (argument.operand.type == 'number') {
							values.push((argument.operand.value == 0 ? argument.operand.value : argument.operand.value * -1));
						}

						else if (argument.operand.type == 'function') {
							let v = [] as any[];
							let t = null as any;

							argument.operand.arguments.forEach((argument: any) => {
								if (argument.type != 'text') {
									this.getFormulaValueByArgument(argument, header, newValue, companyReportSheets, sheetIndex, v);
								}
							});
							t = this.evaluateFunction(argument.operand.name, v);
							values.push((t == 0 ? t : t * -1));

							t = null;
							v = null as any;
						}

						else if (argument.operand.type == 'binary-expression') {
							let v = [] as any[];
							this.getFormulaValueByArgument(argument.operand, header, newValue, companyReportSheets, sheetIndex, v);
							values.push((v[0] == 0 ? v[0] : v[0] * -1));
							v = null as any;
						}
						
						else {
							const rowIndex = this.getRowIndex(argument.operand.key);
							const columnIndex = this.getColumnIndex(argument.operand.key);

							if (header == this.getLetterNumber(argument.operand.key)) {
								values.push((newValue == 0 ? newValue : newValue * -1));
							}
															
							else {
								if (companyReportSheets[sheetIndex].template[rowIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value != null && (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LONGLABEL' || this.isNumericHeaderCell(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex]))) {
									if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.toString().indexOf('%') != -1) {
										values.push(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') == undefined || null ? 0 : (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') / 100) * -1);
									}
									
									else {
										values.push(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value * -1);
									}
								} 
	
								else {
									if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.toString().indexOf('%') != -1) {
										values.push(companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') == undefined || null ? 0 : (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') / 100) * -1);	
									}
	
									else{
										values.push(companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue * -1);	
									}
								}
							}
						}
					}

					else {
						const rowIndex = this.getRowIndex(argument.key);
						const columnIndex = this.getColumnIndex(argument.key);

						if (header == this.getLetterNumber(argument.key)) {
							if (newValue != null && newValue.toString().indexOf('%') != -1) {
								values.push(newValue.toString().indexOf('%') != -1 ? newValue.toString().replace('%', '') / 100 : newValue);
							}
							
							else {
								values.push(newValue == undefined || null ? 0 : newValue);
							}
						}
														
						else {
							if (companyReportSheets[sheetIndex].template[rowIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value != null && (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LABEL' || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].component == 'LONGLABEL' || this.isNumericHeaderCell(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex]))) {
								if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.toString().indexOf('%') != -1) {
									values.push(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.replace('%', '') / 100);
								}
								
								else {
									values.push(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value);
								}
							} 

							else {
								if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.toString().indexOf('%') != -1) {
									values.push(companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue.replace('%', '') / 100);	
								}

								else{
									values.push(companyReportSheets[sheetIndex].template[rowIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex] == null || companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == undefined || null ? 0 : companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue);	
								}
							}
						}
					}
				}
			}

			else if (argument.type == 'number') {
				values.push(argument.value);
			}
		},
		evaluateFunction(name: any, value: any) {
			for (let i = 0; i < value.length; i++){
				if (Number.isNaN(value) || value == '#VALUE!') {
					return '#VALUE!'
				}
			}
			switch (name) {
				case "ABS":
					return formulajs.ABS(value);
				case "AND":
					return formulajs.AND(value);
				case "OR":
					return formulajs.OR(value);
				case "SUM":
					return formulajs.SUM(value);
				case "ROW":
					return this.getNumber(value);
				case "TEXT":
					return value[1].indexOf('.') != -1 ? formulajs.TEXT(value[0],value[1].toString()).toString() : Math.floor(value[0]).toString();
			}
		},
		evaluateExpression(operator: any, leftValue: any, rightValue: any){
			if ((leftValue == '#VALUE!' || rightValue == '#VALUE!')) {
				return '#VALUE!';
			}
			if (operator != '&' && (isNaN(leftValue) || isNaN(rightValue)) && (!(isNaN(leftValue) && isNaN(rightValue)))) {
				return '#VALUE!';
			}
			switch (operator) {
				case ">=":
					return Number(leftValue) >= Number(rightValue);
				case ">":
					return Number(leftValue) > Number(rightValue);
				case "<=":
					return Number(leftValue) <= Number(rightValue);
				case "<":
					return Number(leftValue) < Number(rightValue);
				case "=":
					return Number(leftValue) == Number(rightValue);
				case "<>":
					return Number(leftValue) != Number(rightValue);
				case "+":
					return Number(leftValue) + Number(rightValue);
				case "-":
					return Number(leftValue) - Number(rightValue);
				case "*":
					return Number(leftValue) * Number(rightValue);
				case "/":
					return Number(leftValue) / Number(rightValue);
				case "&":
					return leftValue + rightValue;
			}
		},
		setComponents(companyReportSheets: any[], sheetIndex: any, isOpenDialogue: any) {
			if (isOpenDialogue) {
				if (companyReportSheets[sheetIndex].componentsTimeout != null) {
					companyReportSheets[sheetIndex].componentsTimeout = clearTimeout(companyReportSheets[sheetIndex].componentsTimeout);
				}
				companyReportSheets[sheetIndex].componentsTimeout = setTimeout(() => {
					companyReportSheets[sheetIndex].formulas = [] as any[];
					companyReportSheets[sheetIndex].formulaChilds = {} as any;
					
					companyReportSheets[sheetIndex].navigates = [] as any[];
					
					if (companyReportSheets[sheetIndex].template != null) {
						const rowLength = companyReportSheets[sheetIndex].template.length;
						for (let i = 0; i < rowLength; i++) {
							const columnLength = companyReportSheets[sheetIndex].template[i].columns.length;
							for (let j = 0; j < columnLength; j++) {
								if (companyReportSheets[sheetIndex].template[i].columns[j].component != null) {
									if (companyReportSheets[sheetIndex].template[i].columns[j].component == 'FORMULA' || companyReportSheets[sheetIndex].template[i].columns[j].component == 'VALUE') {
										this.setFormulas(companyReportSheets, companyReportSheets[sheetIndex].template[i].columns[j], i, j, sheetIndex);
									}
									else if (companyReportSheets[sheetIndex].template[i].columns[j].component == 'NAVIGATE') {
										this.setNavigates(companyReportSheets, companyReportSheets[sheetIndex].template[i].columns[j], i, j, sheetIndex);
									}
								}
							}
						}
					}
				}, 0);
			}
				
			else {
				companyReportSheets[sheetIndex].formulas = [] as any[];
				companyReportSheets[sheetIndex].formulaChilds = {} as any;
				
				companyReportSheets[sheetIndex].navigates = [] as any[];
					
				if (companyReportSheets[sheetIndex].template != null) {
					const rowLength = companyReportSheets[sheetIndex].template.length;
					for (let i = 0; i < rowLength; i++) {
						const columnLength = companyReportSheets[sheetIndex].template[i].columns.length;
						for (let j = 0; j < columnLength; j++) {
							if (companyReportSheets[sheetIndex].template[i].columns[j].component != null) {
								if (companyReportSheets[sheetIndex].template[i].columns[j].component == 'FORMULA') {
									this.setFormulas(companyReportSheets, companyReportSheets[sheetIndex].template[i].columns[j], i, j, sheetIndex);
								}
								
								else if (companyReportSheets[sheetIndex].template[i].columns[j].component == 'NAVIGATE') {
									this.setNavigates(companyReportSheets, companyReportSheets[sheetIndex].template[i].columns[j], i, j, sheetIndex);
								}
							}
						}
					}
				}
			}
		},
		tokenizeFormula(companyReportSheets: any[], value: any, newValue: any, header: any, rowIndex: any, columnIndex: any, sheetIndex1: any, sheetIndex2: any) {
			let formulas = null as any;
			let splitFormula = null as any;
			let tokens = [] as any[];
			try {
				formulas = this.parseToken(value, rowIndex, columnIndex);
				if (formulas != null && formulas.length > 0) {
					formulas.slice().reverse().forEach((formula: any, formulaIndex: any) => {
						if (formula.type == 'operand' && formula.subtype == 'range') {
							if (formula.value.includes('!')) {
								splitFormula = formula.value.split('!');
								
								if (formula.value.includes(':')) {
									const cellRangeIndex = companyReportSheets.findIndex(x => x.sheet_code == splitFormula[0] && x.template != null);
									if (cellRangeIndex != -1) {
										const evalFormula = formulas[formulas.length - 2 - formulaIndex].value + '(' + formula.value + ')';
										const result = this.getFormulaValue(this.parseFormulas(evalFormula, companyReportSheets, cellRangeIndex, rowIndex, columnIndex), header, newValue, companyReportSheets, cellRangeIndex);
										tokens.push({from: formulas[formulas.length - 2 - formulaIndex].value + '(' + formula.value + ')', to: result});
									}
								}
								
								else {
									const index = companyReportSheets.findIndex(x => x.sheet_code == splitFormula[0] && x.template != null);
									if (index != -1) {
										const rIndex = this.getRowIndex(splitFormula[1]);
										const cIndex = this.getColumnIndex(splitFormula[1]);
										let replaceValue = 0 as any;

										if (newValue != null && sheetIndex1 == index && header == splitFormula[1]) {
											replaceValue = isNaN(newValue) ? `"${newValue}"` : newValue;
										}
										
										else if (companyReportSheets[index].template[rIndex] != null && companyReportSheets[index].template[rIndex].columns[cIndex] != null) {
											replaceValue = (companyReportSheets[index].template[rIndex].columns[cIndex].actualValue == null || companyReportSheets[index].template[rIndex].columns[cIndex].actualValue == '') ? 0 : companyReportSheets[index].template[rIndex].columns[cIndex].actualValue;
										}
										tokens.push({from: formula.value, to: replaceValue});
									}
								}
							}

							else {
								const rIndex = this.getRowIndex(formula.value);
								const cIndex = this.getColumnIndex(formula.value);
								let replaceValue = 0 as any;
								
								// `header`/`newValue` describe the cell that changed on sheetIndex1. A bare
								// reference belongs to sheetIndex2, so only substitute the incoming value when
								// both sheets are the same - otherwise e.g. a change to Pg_12!D9 would also
								// overwrite the local D9 term of a formula living on Pg_23.
								if (newValue != null && sheetIndex1 == sheetIndex2 && header == formula.value) {
									replaceValue = (newValue == undefined || newValue == null || newValue == '' ) ? 0 : newValue;
								}
										
								else if (companyReportSheets[sheetIndex2].template[rIndex] != null && companyReportSheets[sheetIndex2].template[rIndex].columns[cIndex] != null) {
									if (companyReportSheets[sheetIndex2].template[rIndex].columns[cIndex].actualValue == undefined || companyReportSheets[sheetIndex2].template[rIndex].columns[cIndex].actualValue == null) {
										replaceValue = 0;
									}
									
									else {
										replaceValue = (companyReportSheets[sheetIndex2].template[rIndex].columns[cIndex].actualValue == null || companyReportSheets[sheetIndex2].template[rIndex].columns[cIndex].actualValue == '') ? 0 : companyReportSheets[sheetIndex2].template[rIndex].columns[cIndex].actualValue;
									}
								}
								tokens.push({from: formula.value, to: replaceValue});
							}
						}
					});

					const pattern = new RegExp(tokens.map(t => this.escapeRegExp(t.from)).join('|'), 'g');
					value = value.replace(pattern, (match: any) => {
						const token = tokens.find(t => t.from == match);
						return token ? token.to : match;
					});
					
					// tokens.sort((a, b) => b.from.length - a.from.length);
					// tokens.forEach(token => {
					// 	const regex = new RegExp(this.escapeRegExp(token.from), "g");
					// 	value = value.replace(regex, token.to);
					// })
				}

				if (this.isFormula(value.substring(1))) {
					return (this.parseFormulas(value.substring(1), companyReportSheets, sheetIndex2, rowIndex, columnIndex));
				}

				return {type: 'text', value: value.substring(1)}
			}

			finally {
				splitFormula = null as any;
				formulas = null as any;
				tokens = null as any;
			}
		},
		escapeRegExp(str: string) {
			return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		},
		isFormula(str: any) {
			// Trim whitespace for accurate detection
			str = str.trim();
			
			// Explicitly handle cases where it's just a single "-"
			if (str === "-") return false;
		
			// Check if the string contains at least one arithmetic operator
			const formulaRegex = /^[\d\s\w+\-*/%^().=]+$/;

			// Check if the string is an if or round statement
			const formulaStatement = /^(IF|ROUND)/;
			
			// Ensure the presence of at least one valid arithmetic operation
			const hasOperator = /[-+*/%^=&]/.test(str);
		
			// Exclude cases where '-' is used between words without numbers
			const isHyphenatedText = /^[a-zA-Z\s]+(\s*-\s*[a-zA-Z\s]+)+$/.test(str);

			return (formulaRegex.test(str) || formulaStatement.test(str)) && hasOperator && !isHyphenatedText;
		},
		setFormulas(companyReportSheets: any[], item: any, rowIndex: any, columnIndex: any, sheetIndex: any) {
			if (item.component != null && (item.component == 'FORMULA' || item.component == 'VALUE')) {
				if (item.value != null && item.value != '') {
					let header = this.getHeader(rowIndex, columnIndex);
					let parser = this.parseFormulas(item.value.substring(1), companyReportSheets, sheetIndex, rowIndex, columnIndex);
					if (parser != null) {
						let childs = this.getFormulaChilds(parser) as any[];
						if (childs != null) {
							let key = null as any;
							for (let i = 0; i < childs.length; i++) {
								childs[i] = childs[i].trim();
								
								key = this.getChildHeader(childs[i].replace('$',''));
								if (!key.includes('!')) {
									if (companyReportSheets[sheetIndex].template[0].columns.length <= this.getColumnIndex(key)) {
										return;
									}
								}

								const refRowIndex = this.getRowIndex(key);
								const refColIndex = this.getColumnIndex(key);
								const isDateComponent = companyReportSheets[sheetIndex].template?.[refRowIndex]?.columns?.[refColIndex]?.component == 'DATETIME';

								if (item.component == 'VALUE' && !isDateComponent) {
									continue;
								}
								
								if (!(header in companyReportSheets[sheetIndex].formulaChilds)) {
									companyReportSheets[sheetIndex].formulaChilds[header] = {f: parser};
								}
								
								if (!(key in companyReportSheets[sheetIndex].formulas)) {
									companyReportSheets[sheetIndex].formulas[key] = [];
								}
								
								if (!(companyReportSheets[sheetIndex].formulas[key].includes(header))) {
									companyReportSheets[sheetIndex].formulas[key].push(header);
								}
							}
							key = null;
						}
						childs = null as any;
					}
					parser = null as any;
					header = null as any;
				}
			}
		},
		setNavigates(companyReportSheets: any[], item: any, rowIndex: any, columnIndex: any, sheetIndex: any) {
			if (item.component != null && item.component == 'NAVIGATE') {
				if (item.value != null && item.value != '') {
					let header = this.getHeader(rowIndex, columnIndex);
					if (!(item.value.substring(1) in companyReportSheets[sheetIndex].navigates)) {
						companyReportSheets[sheetIndex].navigates[item.value.substring(1)] = [];
					}
								
					if (!(companyReportSheets[sheetIndex].navigates[item.value.substring(1)].includes(header))) {
						companyReportSheets[sheetIndex].navigates[item.value.substring(1)].push(header);
					}
					header = null as any;
				}
			}
		},
		setValues(companyReportSheets: any[], sheetIndex: any, type: any, isFixedRate: any) {
			// Record the calculation mode so mode-aware formulas (e.g. MIN ignoring 0 in CWK) can read it
			// via isCwkMode() further down the call chain, where the `type` argument is no longer passed.
			(this as any).calculationType = type;
			if (companyReportSheets[sheetIndex].template != null) {
				const rowLength = companyReportSheets[sheetIndex].template.length;
				for (let r = 0; r < rowLength; r++) {
					const columnLength = companyReportSheets[sheetIndex].template[r].columns.length;
					for (let c = columnLength - 1; c >= 0; c--) {
						if (companyReportSheets[sheetIndex].template[r].columns[c].component != null) {
							if (companyReportSheets[sheetIndex].template[r].columns[c].component == 'NUMBER') {
								if (companyReportSheets[sheetIndex].template[r].columns[c].actualValue != null) {
									if (type =='cwk') {
										// if (companyReportSheets[sheetIndex].template[r].columns[c].actualValue != 0) {
											this.changeNumberValue(companyReportSheets, r, c, sheetIndex, false, isFixedRate);
										// }
									}
									
									else {
										this.changeNumberValue(companyReportSheets, r, c, sheetIndex, false, isFixedRate)
									}
									
								}
							}
							
							else if (companyReportSheets[sheetIndex].template[r].columns[c].component == 'TEXT') {
								if (companyReportSheets[sheetIndex].template[r].columns[c].actualValue != null && companyReportSheets[sheetIndex].template[r].columns[c].actualValue != '') {
									this.changeTextValue(companyReportSheets, r, c, sheetIndex, false);
								}
							}

							this.updateCompany(companyReportSheets[sheetIndex].template[r].columns[c]);
						}
					}
				}
			}
		},
		updateCompany(cell: any) {
			if (cell.component === 'COMPANYDROPDOWN') {
				if (cell.actualValue != null && cell.actualValue !== '') {
					companyApi.companyView(cell.actualValue.identifier).then((response: any) => {
						if (response.data != null) {
							cell.actualValue = {
								identifier: response.data.company.identifier,
								code: response.data.company.code,
								name: response.data.company.name,
								currency: response.data.company.currency.code,
								isVirtual: response.data.company.isVirtual
							};
						}
					});
				}
			}

			else if (cell.component === 'COMPANY') {
				if (cell.actualValue != null && cell.actualValue !== '') {

					if (cell.actualValue.debit) {
						companyApi.companyView(cell.actualValue.debit.identifier).then((response: any) => {
							if (response.data != null) {
								cell.actualValue.debit = {
									identifier: response.data.company.identifier,
									code: response.data.company.code,
									name: response.data.company.name,
									currency: response.data.company.currency.code,
									isVirtual: response.data.company.isVirtual
								};
							}
						});
					}

					if (cell.actualValue.credit) {
						companyApi.companyView(cell.actualValue.credit.identifier).then((response: any) => {
							if (response.data != null) {
								cell.actualValue.credit = {
									identifier: response.data.company.identifier,
									code: response.data.company.code,
									name: response.data.company.name,
									currency: response.data.company.currency.code,
									isVirtual: response.data.company.isVirtual
								};
							}
						});
					}
				}
			}
		},
		changeNumberValue(companyReportSheets: any[], rowIndex: any, columnIndex: any, sheetIndex: any, isOpenDialogue: any, isFixedRate: any) {
			let header = this.getHeader(rowIndex, columnIndex);

			this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, header, companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, companyReportSheets[sheetIndex].formulas[header], sheetIndex, isOpenDialogue, isFixedRate);
			//this.changeNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, header, companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);
			this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, header, companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);

			header = null as any;
		},
		changeTextValue(companyReportSheets: any[], rowIndex: any, columnIndex: any, sheetIndex: any, isOpenDialogue: any) {
			let header = this.getHeader(rowIndex, columnIndex);
			
			this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, header, companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, companyReportSheets[sheetIndex].formulas[header], sheetIndex, isOpenDialogue, false);
			//this.changeNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, header, companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, false);
			this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, header, companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, false);
			
			header = null as any;
		},
		changeFormulaValue(companyReportSheets: any[], code: any, header: any, newValue: any, parents: any, sheetIndex: any, isOpenDialogue: any, isFixedRate: any) {
			if (parents != null && companyReportSheets[sheetIndex].formulaChilds != null) {
				let oldActualValue;
				for (let i = 0; i < parents.length; i++) {
					try {
						if (parents[i] in companyReportSheets[sheetIndex].formulaChilds) {
							const rowIndex = this.getRowIndex(parents[i]);
							const columnIndex = this.getColumnIndex(parents[i]);
							
							oldActualValue = companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue;
							if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value.includes('!')) {
								companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue = this.getFormulaValue(this.tokenizeFormula(companyReportSheets, JSON.parse(JSON.stringify(companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].value)), newValue, header, rowIndex, columnIndex, sheetIndex, sheetIndex), header, newValue, companyReportSheets, sheetIndex);
							}
							
							else {
								companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue = this.getFormulaValue(companyReportSheets[sheetIndex].formulaChilds[parents[i]].f, header, newValue, companyReportSheets, sheetIndex);
							}

							if (isFixedRate && sheetIndex == 1 && rowIndex == 60) {
								if (companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != 0) {
									companyReportSheets.forEach(companyReportSheet => {
										if (companyReportSheet.sheet_name == 'EXCHANGE RESERVES') {
											const rowLength = companyReportSheet.template.length;
											for (let r = 0; r < rowLength; r++) {
												if (companyReportSheet.template[r].columns[1].component == 'LABEL' && companyReportSheet.template[r].columns[1].value == 'EDA') {  // 'Foreign exchange adjustments (Group)'
													if (companyReportSheet.template[r].columns[columnIndex].actualValue != null && companyReportSheet.template[r].columns[columnIndex].actualValue != 0) {
														this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], 0, companyReportSheets[sheetIndex].formulas[parents[i]], sheetIndex, isOpenDialogue, isFixedRate);
														this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], 0, sheetIndex, isOpenDialogue, isFixedRate);
													}

													else {
														this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, companyReportSheets[sheetIndex].formulas[parents[i]], sheetIndex, isOpenDialogue, isFixedRate);
														this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);
													}
												}
											}		
										}
									});

									// if (companyReportSheets[87].template[11].columns[columnIndex].actualValue != null && companyReportSheets[87].template[11].columns[columnIndex].actualValue != 0) {
									// 	this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], 0, companyReportSheets[sheetIndex].formulas[parents[i]], sheetIndex, isOpenDialogue, isFixedRate);
									// 	// this.changeNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], 0, sheetIndex, isOpenDialogue, isFixedRate);
									// 	this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], 0, sheetIndex, isOpenDialogue, isFixedRate);
									// }

									// else {
									// 	this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, companyReportSheets[sheetIndex].formulas[parents[i]], sheetIndex, isOpenDialogue, isFixedRate);
									// 	// this.changeNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);
									// 	this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);
									// }
								}
							}

							else {
								if (isOpenDialogue || (!isOpenDialogue && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null) || (!isOpenDialogue && oldActualValue != null && oldActualValue != 0 && companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue == 0)) {
									this.changeFormulaValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, companyReportSheets[sheetIndex].formulas[parents[i]], sheetIndex, isOpenDialogue, isFixedRate);
									//this.changeNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);
									this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[sheetIndex].sheet_code, parents[i], companyReportSheets[sheetIndex].template[rowIndex].columns[columnIndex].actualValue, sheetIndex, isOpenDialogue, isFixedRate);
								}
							}
						}
					}
					
					catch(err) {
						console.log(err);
					}
				}
				oldActualValue = null;
			}
		},
		changeNavigateValue(companyReportSheets: any[], code: any, header: any, newValue: any, sheetIndex: any, isOpenDialogue: any, isFixedRate: any) {
			if (companyReportSheets[sheetIndex].navigateChilds != null) {
				let parents;
				for (let i = 0; i < companyReportSheets[sheetIndex].navigateChilds.length; i++) {
					const index = companyReportSheets[sheetIndex].navigateChilds[i];
					
					parents = companyReportSheets[index].navigates[code + '!' + header];
					if (parents != null && companyReportSheets[index].navigates != null) {
						for (let j = 0; j < parents.length; j++) {
							try {
								const rowIndex = this.getRowIndex(parents[j]);
								const columnIndex = this.getColumnIndex(parents[j]);
								
								companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue = newValue;
								
								if (isOpenDialogue || (!isOpenDialogue && companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue != null)) {
									this.changeFormulaValue(companyReportSheets, companyReportSheets[index].sheet_code, parents[j], newValue, companyReportSheets[index].formulas[parents[j]], index, isOpenDialogue, isFixedRate);
									this.changeNavigateValue(companyReportSheets, companyReportSheets[index].sheet_code, parents[j], newValue, index, isOpenDialogue, isFixedRate);
									this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[index].sheet_code, parents[j], newValue, index, isOpenDialogue, isFixedRate);
								}
							}
							
							catch(err) {
								console.log(err);
							}
						}
					}
				}
				parents = null as any;
			}
		},
		changeFormulaNavigateValue(companyReportSheets: any[], code: any, header: any, newValue: any, sheetIndex: any, isOpenDialogue: any, isFixedRate: any) {
			if (companyReportSheets[sheetIndex].navigateChilds != null) {
				let parents;
				for (let i = 0; i < companyReportSheets[sheetIndex].navigateChilds.length; i++) {
					const index = companyReportSheets[sheetIndex].navigateChilds[i];
					
					parents = companyReportSheets[index].formulas[code + '!' + header];
					if (parents != null && companyReportSheets[index].formulaChilds != null) {
						for (let j = 0; j < parents.length; j++) {
							try {
								if (parents[j] in companyReportSheets[index].formulaChilds) {
									const rowIndex = this.getRowIndex(parents[j]);
									const columnIndex = this.getColumnIndex(parents[j]);
									
									companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue = this.getFormulaValue(this.tokenizeFormula(companyReportSheets, JSON.parse(JSON.stringify(companyReportSheets[index].template[rowIndex].columns[columnIndex].value)), newValue, header, rowIndex, columnIndex, sheetIndex, index), parents[j], newValue, companyReportSheets, index);
									
									if (isOpenDialogue || (!isOpenDialogue && companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue != null)) {
										this.changeFormulaValue(companyReportSheets, companyReportSheets[index].sheet_code, parents[j], companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue, companyReportSheets[index].formulas[parents[j]], index, isOpenDialogue, isFixedRate);
										//this.changeNavigateValue(companyReportSheets, companyReportSheets[index].sheet_code, parents[j], companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue, index, isOpenDialogue, isFixedRate);
										this.changeFormulaNavigateValue(companyReportSheets, companyReportSheets[index].sheet_code, parents[j], companyReportSheets[index].template[rowIndex].columns[columnIndex].actualValue, index, isOpenDialogue, isFixedRate);
									}
								}
							}
							
							catch(err) {
								console.log(err);
							}
						}
					}
				}
				parents = null as any;
			}
		},
        getLetterByOne(current: any, increment = true) {
            const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const result = current.split('');
            let index = result.length - 1;

            while (index >= 0) {
                const char = result[index];
                const charIndex = alphabet.indexOf(char);

                if (increment) {
                    if (char === 'Z') {
                        result[index] = 'A';
                        if (index === 0) {
                            result.unshift('A');
                        }
                    } 
                    else {
                        result[index] = alphabet[charIndex + 1];
                        break;
                    }
                } 
                else {
                    if (char === 'A') {
                        result[index] = 'Z';
                        if (index === 0) {
                            result.shift(); // Remove the leading 'A' if it's the first character
                        }
                    } 
                    else {
                        result[index] = alphabet[charIndex - 1];
                        break;
                    }
                }

                index--;
            }

            return result.join('');
        },
        getLetterByCurrentStep(current: any, n: any) {
            if (!current || typeof n !== "number") {
                return null;
            } // Validate input
            let result = current;
            const increment = n > 0; // Determine whether to increment or decrement
            const steps = Math.abs(n);
            
            for (let i = 0; i < steps; i++) {
                result = this.getLetterByOne(result, increment);
                if (!result) {
                    return null;
                } // Stop if result becomes invalid (e.g., below "A")
            }
            
            return result;
        },
        compareByColumn(a: any, b: any, isGreaterThanOrEqualTo: any) {
            if (a.length > b.length) {
                return true;
            }
            else if (a.length < b.length) {
                return false;
            }

            if (isGreaterThanOrEqualTo == false) {
                return a > b;
            }
            else {
                return a >= b;
            }
        }
	},
};
